import React from 'react'
import {
  BarChart,
  Bar,
  CartesianGrid,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

export default function VerticalBarChart() {
    const data = [
      {
        name: "Financial",
        uv: 50,
      },
      {
        name: "Operations",
        uv: 45,
      },
      {
        name: "Regulatory",
        uv: 23,
      },
      {
        name: "Fraud",
        uv: 27,
      },
      {
        name: "Strategic",
        uv: 78,
      },
    ];
  return (
    <div>
      <BarChart width={520} height={450} data={data}>
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <defs>
          <linearGradient id="colorBar" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#444CE7" stopOpacity={1} />
            <stop offset="100%" stopColor="#22CCEE" stopOpacity={1} />
          </linearGradient>
        </defs>
        <Bar dataKey="uv" fillOpacity={1} fill="url(#colorBar)" />
      </BarChart>
    </div>
  );
}
